"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookMethod = exports.WebhookType = void 0;
var WebhookType;
(function (WebhookType) {
    WebhookType[WebhookType["BOX"] = 0] = "BOX";
    WebhookType[WebhookType["LAMBDA"] = 1] = "LAMBDA";
    WebhookType[WebhookType["PEPPOL"] = 2] = "PEPPOL";
    WebhookType[WebhookType["EXTERNAL_SYNC"] = 3] = "EXTERNAL_SYNC";
})(WebhookType = exports.WebhookType || (exports.WebhookType = {}));
exports.WebhookMethod = {
    POST: "POST",
    PUT: "PUT",
};
